export const TOOL_OPTIONS = [
  {
    name: 'consultar_deuda',
    label: 'Consultar deuda',
    description: 'Lista facturas pendientes y saldos reales del contacto.',
  },
  {
    name: 'listar_facturas_vencidas',
    label: 'Facturas vencidas',
    description: 'Filtra solo comprobantes vencidos para priorizar gestión.',
  },
  {
    name: 'obtener_factura',
    label: 'Ver una factura',
    description: 'Busca una factura puntual por número para responder sobre ella.',
  },
  {
    name: 'enviar_factura',
    label: 'Enviar factura',
    description: 'Envía el detalle de una factura solicitada.',
  },
  {
    name: 'obtener_medios_pago',
    label: 'Medios de pago',
    description: 'Comparte los medios que configures abajo (CBU, alias, link, etc.).',
  },
  {
    name: 'registrar_promesa_pago',
    label: 'Compromiso de pago',
    description: 'Guarda fecha y monto comprometidos. No confirma el pago solo.',
  },
  {
    name: 'recibir_comprobante',
    label: 'Recibir comprobante',
    description: 'Si el cliente adjunta archivo, crea caso en Excepciones para verificación.',
  },
  {
    name: 'declarar_pago',
    label: 'Informar que pagó',
    description: 'Cuando dice "ya pagué" sin archivo. Deriva a Excepciones para un operador.',
  },
  {
    name: 'consultar_pago',
    label: 'Consultar estado de pago',
    description: 'Solo informa el estado del último pago registrado. No crea pagos nuevos.',
  },
  {
    name: 'crear_reclamo',
    label: 'Reclamo',
    description: 'Deriva a Excepciones. El operador responde por el mismo chat de WhatsApp.',
  },
  {
    name: 'derivar_humano',
    label: 'Derivar a operador',
    description: 'Pide hablar con una persona. Misma bandeja de Excepciones que reclamos.',
  },
  {
    name: 'identificar_deudor',
    label: 'Identificar deudor',
    description: 'Vincula teléfono, email o factura con la cartera antes de consultar deudas.',
  },
  {
    name: 'actualizar_contacto',
    label: 'Actualizar datos',
    description: 'Guarda el email o la razón social que el cliente corrige en la charla.',
  },
] as const;

/**
 * Con todas las herramientas tildadas se guarda la lista vacía: el agente usa el set completo,
 * incluidas las herramientas que se agreguen después.
 */
export function toolsToPersist(selected: readonly string[]): string[] {
  const all = TOOL_OPTIONS.map(item => item.name as string);
  const complete = all.every(name => selected.includes(name));
  return complete ? [] : [...selected];
}
